"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryAllMetadataCreatorResponse = exports.QueryAllMetadataCreatorRequest = exports.QueryGetMetadataCreatorResponse = exports.QueryGetMetadataCreatorRequest = exports.QueryGetNFTFeeBalanceResponse = exports.QueryGetNFTFeeBalanceRequest = exports.QueryGetNFTFeeConfigResponse = exports.QueryGetNFTFeeConfigRequest = exports.QueryAllNFTSchemaByContractResponse = exports.QueryAllNFTSchemaByContractRequest = exports.QueryGetNFTSchemaByContractResponse = exports.QueryGetNFTSchemaByContractRequest = exports.QueryGetNftCollectionResponse = exports.QueryGetNftCollectionRequest = exports.QueryAllOrganizationResponse = exports.QueryAllOrganizationRequest = exports.QueryGetOrganizationResponse = exports.QueryGetOrganizationRequest = exports.QueryAllActionByRefIdResponse = exports.QueryAllActionByRefIdRequest = exports.QueryGetActionByRefIdResponse = exports.QueryGetActionByRefIdRequest = exports.QueryAllNftDataResponse = exports.QueryAllNftDataRequest = exports.QueryGetNftDataResponse = exports.QueryGetNftDataRequest = exports.QueryAllNFTSchemaResponseV072 = exports.QueryAllNFTSchemaResponseV063 = exports.QueryAllNFTSchemaResponse = exports.QueryAllNFTSchemaRequest = exports.QueryGetNFTSchemaResponseV072 = exports.QueryGetNFTSchemaResponseV063 = exports.QueryGetNFTSchemaResponse = exports.QueryGetNFTSchemaRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const minimal_1 = require("protobufjs/minimal");
const params_1 = require("../nftmngr/params");
const nft_schema_1 = require("../nftmngr/nft_schema");
const pagination_1 = require("../cosmos/base/query/v1beta1/pagination");
const nft_data_1 = require("../nftmngr/nft_data");
const action_by_ref_id_1 = require("../nftmngr/action_by_ref_id");
const organization_1 = require("../nftmngr/organization");
const nft_schema_by_contract_1 = require("../nftmngr/nft_schema_by_contract");
const nft_fee_config_1 = require("../nftmngr/nft_fee_config");
const nft_fee_balance_1 = require("../nftmngr/nft_fee_balance");
const metadata_creator_1 = require("../nftmngr/metadata_creator");
exports.protobufPackage = "thesixnetwork.sixnft.nftmngr";
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = params_1.Params.fromJSON(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        if (object.params !== undefined && object.params !== null) {
            message.params = params_1.Params.fromPartial(object.params);
        }
        else {
            message.params = undefined;
        }
        return message;
    },
};
const baseQueryGetNFTSchemaRequest = { code: "" };
exports.QueryGetNFTSchemaRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.code !== "") {
            writer.uint32(10).string(message.code);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNFTSchemaRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.code = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetNFTSchemaRequest);
        if (object.code !== undefined && object.code !== null) {
            message.code = String(object.code);
        }
        else {
            message.code = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.code !== undefined && (obj.code = message.code);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetNFTSchemaRequest);
        if (object.code !== undefined && object.code !== null) {
            message.code = object.code;
        }
        else {
            message.code = "";
        }
        return message;
    },
};
const baseQueryGetNFTSchemaResponse = {};
exports.QueryGetNFTSchemaResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.nFTSchema !== undefined) {
            nft_schema_1.NFTSchema.encode(message.nFTSchema, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNFTSchemaResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nFTSchema = nft_schema_1.NFTSchema.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetNFTSchemaResponse);
        if (object.nFTSchema !== undefined && object.nFTSchema !== null) {
            message.nFTSchema = nft_schema_1.NFTSchema.fromJSON(object.nFTSchema);
        }
        else {
            message.nFTSchema = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nFTSchema !== undefined &&
            (obj.nFTSchema = message.nFTSchema
                ? nft_schema_1.NFTSchema.toJSON(message.nFTSchema)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetNFTSchemaResponse);
        if (object.nFTSchema !== undefined && object.nFTSchema !== null) {
            message.nFTSchema = nft_schema_1.NFTSchema.fromPartial(object.nFTSchema);
        }
        else {
            message.nFTSchema = undefined;
        }
        return message;
    },
};
const baseQueryGetNFTSchemaResponseV063 = {};
exports.QueryGetNFTSchemaResponseV063 = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.nFTSchemaV063 !== undefined) {
            nft_schema_1.NFTSchemaV063.encode(message.nFTSchemaV063, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNFTSchemaResponseV063);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nFTSchemaV063 = nft_schema_1.NFTSchemaV063.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetNFTSchemaResponseV063);
        if (object.nFTSchemaV063 !== undefined && object.nFTSchemaV063 !== null) {
            message.nFTSchemaV063 = nft_schema_1.NFTSchemaV063.fromJSON(object.nFTSchemaV063);
        }
        else {
            message.nFTSchemaV063 = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nFTSchemaV063 !== undefined &&
            (obj.nFTSchemaV063 = message.nFTSchemaV063
                ? nft_schema_1.NFTSchemaV063.toJSON(message.nFTSchemaV063)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetNFTSchemaResponseV063);
        if (object.nFTSchemaV063 !== undefined && object.nFTSchemaV063 !== null) {
            message.nFTSchemaV063 = nft_schema_1.NFTSchemaV063.fromPartial(object.nFTSchemaV063);
        }
        else {
            message.nFTSchemaV063 = undefined;
        }
        return message;
    },
};
const baseQueryGetNFTSchemaResponseV072 = {};
exports.QueryGetNFTSchemaResponseV072 = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.nFTSchemaV072 !== undefined) {
            nft_schema_1.NFTSchemaV072.encode(message.nFTSchemaV072, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNFTSchemaResponseV072);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nFTSchemaV072 = nft_schema_1.NFTSchemaV072.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetNFTSchemaResponseV072);
        if (object.nFTSchemaV072 !== undefined && object.nFTSchemaV072 !== null) {
            message.nFTSchemaV072 = nft_schema_1.NFTSchemaV072.fromJSON(object.nFTSchemaV072);
        }
        else {
            message.nFTSchemaV072 = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nFTSchemaV072 !== undefined &&
            (obj.nFTSchemaV072 = message.nFTSchemaV072
                ? nft_schema_1.NFTSchemaV072.toJSON(message.nFTSchemaV072)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetNFTSchemaResponseV072);
        if (object.nFTSchemaV072 !== undefined && object.nFTSchemaV072 !== null) {
            message.nFTSchemaV072 = nft_schema_1.NFTSchemaV072.fromPartial(object.nFTSchemaV072);
        }
        else {
            message.nFTSchemaV072 = undefined;
        }
        return message;
    },
};
const baseQueryAllNFTSchemaRequest = {};
exports.QueryAllNFTSchemaRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllNFTSchemaRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllNFTSchemaRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllNFTSchemaRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllNFTSchemaResponse = {};
exports.QueryAllNFTSchemaResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.nFTSchema) {
            nft_schema_1.NFTSchema.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllNFTSchemaResponse);
        message.nFTSchema = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nFTSchema.push(nft_schema_1.NFTSchema.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllNFTSchemaResponse);
        message.nFTSchema = [];
        if (object.nFTSchema !== undefined && object.nFTSchema !== null) {
            for (const e of object.nFTSchema) {
                message.nFTSchema.push(nft_schema_1.NFTSchema.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nFTSchema) {
            obj.nFTSchema = message.nFTSchema.map((e) => e ? nft_schema_1.NFTSchema.toJSON(e) : undefined);
        }
        else {
            obj.nFTSchema = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllNFTSchemaResponse);
        message.nFTSchema = [];
        if (object.nFTSchema !== undefined && object.nFTSchema !== null) {
            for (const e of object.nFTSchema) {
                message.nFTSchema.push(nft_schema_1.NFTSchema.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllNFTSchemaResponseV063 = {};
exports.QueryAllNFTSchemaResponseV063 = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.nFTSchemaV063) {
            nft_schema_1.NFTSchemaV063.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllNFTSchemaResponseV063);
        message.nFTSchemaV063 = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nFTSchemaV063.push(nft_schema_1.NFTSchemaV063.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllNFTSchemaResponseV063);
        message.nFTSchemaV063 = [];
        if (object.nFTSchemaV063 !== undefined && object.nFTSchemaV063 !== null) {
            for (const e of object.nFTSchemaV063) {
                message.nFTSchemaV063.push(nft_schema_1.NFTSchemaV063.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nFTSchemaV063) {
            obj.nFTSchemaV063 = message.nFTSchemaV063.map((e) => e ? nft_schema_1.NFTSchemaV063.toJSON(e) : undefined);
        }
        else {
            obj.nFTSchemaV063 = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllNFTSchemaResponseV063);
        message.nFTSchemaV063 = [];
        if (object.nFTSchemaV063 !== undefined && object.nFTSchemaV063 !== null) {
            for (const e of object.nFTSchemaV063) {
                message.nFTSchemaV063.push(nft_schema_1.NFTSchemaV063.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllNFTSchemaResponseV072 = {};
exports.QueryAllNFTSchemaResponseV072 = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.nFTSchemaV072) {
            nft_schema_1.NFTSchemaV072.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllNFTSchemaResponseV072);
        message.nFTSchemaV072 = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nFTSchemaV072.push(nft_schema_1.NFTSchemaV072.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllNFTSchemaResponseV072);
        message.nFTSchemaV072 = [];
        if (object.nFTSchemaV072 !== undefined && object.nFTSchemaV072 !== null) {
            for (const e of object.nFTSchemaV072) {
                message.nFTSchemaV072.push(nft_schema_1.NFTSchemaV072.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nFTSchemaV072) {
            obj.nFTSchemaV072 = message.nFTSchemaV072.map((e) => e ? nft_schema_1.NFTSchemaV072.toJSON(e) : undefined);
        }
        else {
            obj.nFTSchemaV072 = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllNFTSchemaResponseV072);
        message.nFTSchemaV072 = [];
        if (object.nFTSchemaV072 !== undefined && object.nFTSchemaV072 !== null) {
            for (const e of object.nFTSchemaV072) {
                message.nFTSchemaV072.push(nft_schema_1.NFTSchemaV072.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetNftDataRequest = { nftSchemaCode: "", tokenId: "" };
exports.QueryGetNftDataRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.nftSchemaCode !== "") {
            writer.uint32(10).string(message.nftSchemaCode);
        }
        if (message.tokenId !== "") {
            writer.uint32(18).string(message.tokenId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNftDataRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftSchemaCode = reader.string();
                    break;
                case 2:
                    message.tokenId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetNftDataRequest);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = String(object.tokenId);
        }
        else {
            message.tokenId = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.tokenId !== undefined && (obj.tokenId = message.tokenId);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetNftDataRequest);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.tokenId !== undefined && object.tokenId !== null) {
            message.tokenId = object.tokenId;
        }
        else {
            message.tokenId = "";
        }
        return message;
    },
};
const baseQueryGetNftDataResponse = {};
exports.QueryGetNftDataResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.nftData !== undefined) {
            nft_data_1.NftData.encode(message.nftData, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNftDataResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftData = nft_data_1.NftData.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetNftDataResponse);
        if (object.nftData !== undefined && object.nftData !== null) {
            message.nftData = nft_data_1.NftData.fromJSON(object.nftData);
        }
        else {
            message.nftData = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nftData !== undefined &&
            (obj.nftData = message.nftData
                ? nft_data_1.NftData.toJSON(message.nftData)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetNftDataResponse);
        if (object.nftData !== undefined && object.nftData !== null) {
            message.nftData = nft_data_1.NftData.fromPartial(object.nftData);
        }
        else {
            message.nftData = undefined;
        }
        return message;
    },
};
const baseQueryAllNftDataRequest = {};
exports.QueryAllNftDataRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllNftDataRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllNftDataRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllNftDataRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllNftDataResponse = {};
exports.QueryAllNftDataResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.nftData) {
            nft_data_1.NftData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllNftDataResponse);
        message.nftData = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftData.push(nft_data_1.NftData.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllNftDataResponse);
        message.nftData = [];
        if (object.nftData !== undefined && object.nftData !== null) {
            for (const e of object.nftData) {
                message.nftData.push(nft_data_1.NftData.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nftData) {
            obj.nftData = message.nftData.map((e) => e ? nft_data_1.NftData.toJSON(e) : undefined);
        }
        else {
            obj.nftData = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllNftDataResponse);
        message.nftData = [];
        if (object.nftData !== undefined && object.nftData !== null) {
            for (const e of object.nftData) {
                message.nftData.push(nft_data_1.NftData.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetActionByRefIdRequest = { refId: "" };
exports.QueryGetActionByRefIdRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.refId !== "") {
            writer.uint32(10).string(message.refId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetActionByRefIdRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.refId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetActionByRefIdRequest);
        if (object.refId !== undefined && object.refId !== null) {
            message.refId = String(object.refId);
        }
        else {
            message.refId = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.refId !== undefined && (obj.refId = message.refId);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetActionByRefIdRequest);
        if (object.refId !== undefined && object.refId !== null) {
            message.refId = object.refId;
        }
        else {
            message.refId = "";
        }
        return message;
    },
};
const baseQueryGetActionByRefIdResponse = {};
exports.QueryGetActionByRefIdResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.actionByRefId !== undefined) {
            action_by_ref_id_1.ActionByRefId.encode(message.actionByRefId, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetActionByRefIdResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.actionByRefId = action_by_ref_id_1.ActionByRefId.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetActionByRefIdResponse);
        if (object.actionByRefId !== undefined && object.actionByRefId !== null) {
            message.actionByRefId = action_by_ref_id_1.ActionByRefId.fromJSON(object.actionByRefId);
        }
        else {
            message.actionByRefId = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.actionByRefId !== undefined &&
            (obj.actionByRefId = message.actionByRefId
                ? action_by_ref_id_1.ActionByRefId.toJSON(message.actionByRefId)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetActionByRefIdResponse);
        if (object.actionByRefId !== undefined && object.actionByRefId !== null) {
            message.actionByRefId = action_by_ref_id_1.ActionByRefId.fromPartial(object.actionByRefId);
        }
        else {
            message.actionByRefId = undefined;
        }
        return message;
    },
};
const baseQueryAllActionByRefIdRequest = {};
exports.QueryAllActionByRefIdRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllActionByRefIdRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllActionByRefIdRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllActionByRefIdRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllActionByRefIdResponse = {};
exports.QueryAllActionByRefIdResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.actionByRefId) {
            action_by_ref_id_1.ActionByRefId.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllActionByRefIdResponse);
        message.actionByRefId = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.actionByRefId.push(action_by_ref_id_1.ActionByRefId.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllActionByRefIdResponse);
        message.actionByRefId = [];
        if (object.actionByRefId !== undefined && object.actionByRefId !== null) {
            for (const e of object.actionByRefId) {
                message.actionByRefId.push(action_by_ref_id_1.ActionByRefId.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.actionByRefId) {
            obj.actionByRefId = message.actionByRefId.map((e) => e ? action_by_ref_id_1.ActionByRefId.toJSON(e) : undefined);
        }
        else {
            obj.actionByRefId = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllActionByRefIdResponse);
        message.actionByRefId = [];
        if (object.actionByRefId !== undefined && object.actionByRefId !== null) {
            for (const e of object.actionByRefId) {
                message.actionByRefId.push(action_by_ref_id_1.ActionByRefId.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetOrganizationRequest = { name: "" };
exports.QueryGetOrganizationRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetOrganizationRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetOrganizationRequest);
        if (object.name !== undefined && object.name !== null) {
            message.name = String(object.name);
        }
        else {
            message.name = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetOrganizationRequest);
        if (object.name !== undefined && object.name !== null) {
            message.name = object.name;
        }
        else {
            message.name = "";
        }
        return message;
    },
};
const baseQueryGetOrganizationResponse = {};
exports.QueryGetOrganizationResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.organization !== undefined) {
            organization_1.Organization.encode(message.organization, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetOrganizationResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.organization = organization_1.Organization.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetOrganizationResponse);
        if (object.organization !== undefined && object.organization !== null) {
            message.organization = organization_1.Organization.fromJSON(object.organization);
        }
        else {
            message.organization = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.organization !== undefined &&
            (obj.organization = message.organization
                ? organization_1.Organization.toJSON(message.organization)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetOrganizationResponse);
        if (object.organization !== undefined && object.organization !== null) {
            message.organization = organization_1.Organization.fromPartial(object.organization);
        }
        else {
            message.organization = undefined;
        }
        return message;
    },
};
const baseQueryAllOrganizationRequest = {};
exports.QueryAllOrganizationRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllOrganizationRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllOrganizationRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllOrganizationRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllOrganizationResponse = {};
exports.QueryAllOrganizationResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.organization) {
            organization_1.Organization.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllOrganizationResponse);
        message.organization = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.organization.push(organization_1.Organization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllOrganizationResponse);
        message.organization = [];
        if (object.organization !== undefined && object.organization !== null) {
            for (const e of object.organization) {
                message.organization.push(organization_1.Organization.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.organization) {
            obj.organization = message.organization.map((e) => e ? organization_1.Organization.toJSON(e) : undefined);
        }
        else {
            obj.organization = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllOrganizationResponse);
        message.organization = [];
        if (object.organization !== undefined && object.organization !== null) {
            for (const e of object.organization) {
                message.organization.push(organization_1.Organization.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetNftCollectionRequest = { nftSchemaCode: "" };
exports.QueryGetNftCollectionRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.nftSchemaCode !== "") {
            writer.uint32(10).string(message.nftSchemaCode);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNftCollectionRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftSchemaCode = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetNftCollectionRequest);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetNftCollectionRequest);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetNftCollectionResponse = {};
exports.QueryGetNftCollectionResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.nftCollection) {
            nft_data_1.NftData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNftCollectionResponse);
        message.nftCollection = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftCollection.push(nft_data_1.NftData.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetNftCollectionResponse);
        message.nftCollection = [];
        if (object.nftCollection !== undefined && object.nftCollection !== null) {
            for (const e of object.nftCollection) {
                message.nftCollection.push(nft_data_1.NftData.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nftCollection) {
            obj.nftCollection = message.nftCollection.map((e) => e ? nft_data_1.NftData.toJSON(e) : undefined);
        }
        else {
            obj.nftCollection = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetNftCollectionResponse);
        message.nftCollection = [];
        if (object.nftCollection !== undefined && object.nftCollection !== null) {
            for (const e of object.nftCollection) {
                message.nftCollection.push(nft_data_1.NftData.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetNFTSchemaByContractRequest = {
    originContractAddress: "",
};
exports.QueryGetNFTSchemaByContractRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.originContractAddress !== "") {
            writer.uint32(10).string(message.originContractAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNFTSchemaByContractRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.originContractAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetNFTSchemaByContractRequest);
        if (object.originContractAddress !== undefined &&
            object.originContractAddress !== null) {
            message.originContractAddress = String(object.originContractAddress);
        }
        else {
            message.originContractAddress = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.originContractAddress !== undefined &&
            (obj.originContractAddress = message.originContractAddress);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetNFTSchemaByContractRequest);
        if (object.originContractAddress !== undefined &&
            object.originContractAddress !== null) {
            message.originContractAddress = object.originContractAddress;
        }
        else {
            message.originContractAddress = "";
        }
        return message;
    },
};
const baseQueryGetNFTSchemaByContractResponse = {};
exports.QueryGetNFTSchemaByContractResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.nFTSchemaByContract !== undefined) {
            nft_schema_by_contract_1.NFTSchemaByContract.encode(message.nFTSchemaByContract, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNFTSchemaByContractResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nFTSchemaByContract = nft_schema_by_contract_1.NFTSchemaByContract.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetNFTSchemaByContractResponse);
        if (object.nFTSchemaByContract !== undefined &&
            object.nFTSchemaByContract !== null) {
            message.nFTSchemaByContract = nft_schema_by_contract_1.NFTSchemaByContract.fromJSON(object.nFTSchemaByContract);
        }
        else {
            message.nFTSchemaByContract = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nFTSchemaByContract !== undefined &&
            (obj.nFTSchemaByContract = message.nFTSchemaByContract
                ? nft_schema_by_contract_1.NFTSchemaByContract.toJSON(message.nFTSchemaByContract)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetNFTSchemaByContractResponse);
        if (object.nFTSchemaByContract !== undefined &&
            object.nFTSchemaByContract !== null) {
            message.nFTSchemaByContract = nft_schema_by_contract_1.NFTSchemaByContract.fromPartial(object.nFTSchemaByContract);
        }
        else {
            message.nFTSchemaByContract = undefined;
        }
        return message;
    },
};
const baseQueryAllNFTSchemaByContractRequest = {};
exports.QueryAllNFTSchemaByContractRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllNFTSchemaByContractRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllNFTSchemaByContractRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllNFTSchemaByContractRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllNFTSchemaByContractResponse = {};
exports.QueryAllNFTSchemaByContractResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.nFTSchemaByContract) {
            nft_schema_by_contract_1.NFTSchemaByContract.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllNFTSchemaByContractResponse);
        message.nFTSchemaByContract = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nFTSchemaByContract.push(nft_schema_by_contract_1.NFTSchemaByContract.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllNFTSchemaByContractResponse);
        message.nFTSchemaByContract = [];
        if (object.nFTSchemaByContract !== undefined &&
            object.nFTSchemaByContract !== null) {
            for (const e of object.nFTSchemaByContract) {
                message.nFTSchemaByContract.push(nft_schema_by_contract_1.NFTSchemaByContract.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nFTSchemaByContract) {
            obj.nFTSchemaByContract = message.nFTSchemaByContract.map((e) => e ? nft_schema_by_contract_1.NFTSchemaByContract.toJSON(e) : undefined);
        }
        else {
            obj.nFTSchemaByContract = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllNFTSchemaByContractResponse);
        message.nFTSchemaByContract = [];
        if (object.nFTSchemaByContract !== undefined &&
            object.nFTSchemaByContract !== null) {
            for (const e of object.nFTSchemaByContract) {
                message.nFTSchemaByContract.push(nft_schema_by_contract_1.NFTSchemaByContract.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryGetNFTFeeConfigRequest = {};
exports.QueryGetNFTFeeConfigRequest = {
    encode(_, writer = minimal_1.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNFTFeeConfigRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryGetNFTFeeConfigRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryGetNFTFeeConfigRequest);
        return message;
    },
};
const baseQueryGetNFTFeeConfigResponse = {};
exports.QueryGetNFTFeeConfigResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.NFTFeeConfig !== undefined) {
            nft_fee_config_1.NFTFeeConfig.encode(message.NFTFeeConfig, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNFTFeeConfigResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.NFTFeeConfig = nft_fee_config_1.NFTFeeConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetNFTFeeConfigResponse);
        if (object.NFTFeeConfig !== undefined && object.NFTFeeConfig !== null) {
            message.NFTFeeConfig = nft_fee_config_1.NFTFeeConfig.fromJSON(object.NFTFeeConfig);
        }
        else {
            message.NFTFeeConfig = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.NFTFeeConfig !== undefined &&
            (obj.NFTFeeConfig = message.NFTFeeConfig
                ? nft_fee_config_1.NFTFeeConfig.toJSON(message.NFTFeeConfig)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetNFTFeeConfigResponse);
        if (object.NFTFeeConfig !== undefined && object.NFTFeeConfig !== null) {
            message.NFTFeeConfig = nft_fee_config_1.NFTFeeConfig.fromPartial(object.NFTFeeConfig);
        }
        else {
            message.NFTFeeConfig = undefined;
        }
        return message;
    },
};
const baseQueryGetNFTFeeBalanceRequest = {};
exports.QueryGetNFTFeeBalanceRequest = {
    encode(_, writer = minimal_1.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNFTFeeBalanceRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryGetNFTFeeBalanceRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryGetNFTFeeBalanceRequest);
        return message;
    },
};
const baseQueryGetNFTFeeBalanceResponse = {};
exports.QueryGetNFTFeeBalanceResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.NFTFeeBalance !== undefined) {
            nft_fee_balance_1.NFTFeeBalance.encode(message.NFTFeeBalance, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetNFTFeeBalanceResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.NFTFeeBalance = nft_fee_balance_1.NFTFeeBalance.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetNFTFeeBalanceResponse);
        if (object.NFTFeeBalance !== undefined && object.NFTFeeBalance !== null) {
            message.NFTFeeBalance = nft_fee_balance_1.NFTFeeBalance.fromJSON(object.NFTFeeBalance);
        }
        else {
            message.NFTFeeBalance = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.NFTFeeBalance !== undefined &&
            (obj.NFTFeeBalance = message.NFTFeeBalance
                ? nft_fee_balance_1.NFTFeeBalance.toJSON(message.NFTFeeBalance)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetNFTFeeBalanceResponse);
        if (object.NFTFeeBalance !== undefined && object.NFTFeeBalance !== null) {
            message.NFTFeeBalance = nft_fee_balance_1.NFTFeeBalance.fromPartial(object.NFTFeeBalance);
        }
        else {
            message.NFTFeeBalance = undefined;
        }
        return message;
    },
};
const baseQueryGetMetadataCreatorRequest = { nftSchemaCode: "" };
exports.QueryGetMetadataCreatorRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.nftSchemaCode !== "") {
            writer.uint32(10).string(message.nftSchemaCode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetMetadataCreatorRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftSchemaCode = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetMetadataCreatorRequest);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = String(object.nftSchemaCode);
        }
        else {
            message.nftSchemaCode = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nftSchemaCode !== undefined &&
            (obj.nftSchemaCode = message.nftSchemaCode);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetMetadataCreatorRequest);
        if (object.nftSchemaCode !== undefined && object.nftSchemaCode !== null) {
            message.nftSchemaCode = object.nftSchemaCode;
        }
        else {
            message.nftSchemaCode = "";
        }
        return message;
    },
};
const baseQueryGetMetadataCreatorResponse = {};
exports.QueryGetMetadataCreatorResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.metadataCreator !== undefined) {
            metadata_creator_1.MetadataCreator.encode(message.metadataCreator, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetMetadataCreatorResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.metadataCreator = metadata_creator_1.MetadataCreator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetMetadataCreatorResponse);
        if (object.metadataCreator !== undefined &&
            object.metadataCreator !== null) {
            message.metadataCreator = metadata_creator_1.MetadataCreator.fromJSON(object.metadataCreator);
        }
        else {
            message.metadataCreator = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.metadataCreator !== undefined &&
            (obj.metadataCreator = message.metadataCreator
                ? metadata_creator_1.MetadataCreator.toJSON(message.metadataCreator)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetMetadataCreatorResponse);
        if (object.metadataCreator !== undefined &&
            object.metadataCreator !== null) {
            message.metadataCreator = metadata_creator_1.MetadataCreator.fromPartial(object.metadataCreator);
        }
        else {
            message.metadataCreator = undefined;
        }
        return message;
    },
};
const baseQueryAllMetadataCreatorRequest = {};
exports.QueryAllMetadataCreatorRequest = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllMetadataCreatorRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllMetadataCreatorRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllMetadataCreatorRequest);
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageRequest.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
const baseQueryAllMetadataCreatorResponse = {};
exports.QueryAllMetadataCreatorResponse = {
    encode(message, writer = minimal_1.Writer.create()) {
        for (const v of message.metadataCreator) {
            metadata_creator_1.MetadataCreator.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllMetadataCreatorResponse);
        message.metadataCreator = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.metadataCreator.push(metadata_creator_1.MetadataCreator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllMetadataCreatorResponse);
        message.metadataCreator = [];
        if (object.metadataCreator !== undefined &&
            object.metadataCreator !== null) {
            for (const e of object.metadataCreator) {
                message.metadataCreator.push(metadata_creator_1.MetadataCreator.fromJSON(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromJSON(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.metadataCreator) {
            obj.metadataCreator = message.metadataCreator.map((e) => e ? metadata_creator_1.MetadataCreator.toJSON(e) : undefined);
        }
        else {
            obj.metadataCreator = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllMetadataCreatorResponse);
        message.metadataCreator = [];
        if (object.metadataCreator !== undefined &&
            object.metadataCreator !== null) {
            for (const e of object.metadataCreator) {
                message.metadataCreator.push(metadata_creator_1.MetadataCreator.fromPartial(e));
            }
        }
        if (object.pagination !== undefined && object.pagination !== null) {
            message.pagination = pagination_1.PageResponse.fromPartial(object.pagination);
        }
        else {
            message.pagination = undefined;
        }
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.Reader(data)));
    }
    NFTSchema(request) {
        const data = exports.QueryGetNFTSchemaRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NFTSchema", data);
        return promise.then((data) => exports.QueryGetNFTSchemaResponse.decode(new minimal_1.Reader(data)));
    }
    NFTSchemaV063(request) {
        const data = exports.QueryGetNFTSchemaRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NFTSchemaV063", data);
        return promise.then((data) => exports.QueryGetNFTSchemaResponseV063.decode(new minimal_1.Reader(data)));
    }
    NFTSchemaV072(request) {
        const data = exports.QueryGetNFTSchemaRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NFTSchemaV072", data);
        return promise.then((data) => exports.QueryGetNFTSchemaResponseV072.decode(new minimal_1.Reader(data)));
    }
    NFTSchemaAll(request) {
        const data = exports.QueryAllNFTSchemaRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NFTSchemaAll", data);
        return promise.then((data) => exports.QueryAllNFTSchemaResponse.decode(new minimal_1.Reader(data)));
    }
    NFTSchemaAllV063(request) {
        const data = exports.QueryAllNFTSchemaRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NFTSchemaAllV063", data);
        return promise.then((data) => exports.QueryAllNFTSchemaResponseV063.decode(new minimal_1.Reader(data)));
    }
    NFTSchemaAllV072(request) {
        const data = exports.QueryAllNFTSchemaRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NFTSchemaAllV072", data);
        return promise.then((data) => exports.QueryAllNFTSchemaResponseV072.decode(new minimal_1.Reader(data)));
    }
    NftData(request) {
        const data = exports.QueryGetNftDataRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NftData", data);
        return promise.then((data) => exports.QueryGetNftDataResponse.decode(new minimal_1.Reader(data)));
    }
    NftDataAll(request) {
        const data = exports.QueryAllNftDataRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NftDataAll", data);
        return promise.then((data) => exports.QueryAllNftDataResponse.decode(new minimal_1.Reader(data)));
    }
    ActionByRefId(request) {
        const data = exports.QueryGetActionByRefIdRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "ActionByRefId", data);
        return promise.then((data) => exports.QueryGetActionByRefIdResponse.decode(new minimal_1.Reader(data)));
    }
    ActionByRefIdAll(request) {
        const data = exports.QueryAllActionByRefIdRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "ActionByRefIdAll", data);
        return promise.then((data) => exports.QueryAllActionByRefIdResponse.decode(new minimal_1.Reader(data)));
    }
    Organization(request) {
        const data = exports.QueryGetOrganizationRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "Organization", data);
        return promise.then((data) => exports.QueryGetOrganizationResponse.decode(new minimal_1.Reader(data)));
    }
    OrganizationAll(request) {
        const data = exports.QueryAllOrganizationRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "OrganizationAll", data);
        return promise.then((data) => exports.QueryAllOrganizationResponse.decode(new minimal_1.Reader(data)));
    }
    NftCollection(request) {
        const data = exports.QueryGetNftCollectionRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NftCollection", data);
        return promise.then((data) => exports.QueryGetNftCollectionResponse.decode(new minimal_1.Reader(data)));
    }
    NFTSchemaByContract(request) {
        const data = exports.QueryGetNFTSchemaByContractRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NFTSchemaByContract", data);
        return promise.then((data) => exports.QueryGetNFTSchemaByContractResponse.decode(new minimal_1.Reader(data)));
    }
    NFTSchemaByContractAll(request) {
        const data = exports.QueryAllNFTSchemaByContractRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NFTSchemaByContractAll", data);
        return promise.then((data) => exports.QueryAllNFTSchemaByContractResponse.decode(new minimal_1.Reader(data)));
    }
    NFTFeeConfig(request) {
        const data = exports.QueryGetNFTFeeConfigRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NFTFeeConfig", data);
        return promise.then((data) => exports.QueryGetNFTFeeConfigResponse.decode(new minimal_1.Reader(data)));
    }
    NFTFeeBalance(request) {
        const data = exports.QueryGetNFTFeeBalanceRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "NFTFeeBalance", data);
        return promise.then((data) => exports.QueryGetNFTFeeBalanceResponse.decode(new minimal_1.Reader(data)));
    }
    MetadataCreator(request) {
        const data = exports.QueryGetMetadataCreatorRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "MetadataCreator", data);
        return promise.then((data) => exports.QueryGetMetadataCreatorResponse.decode(new minimal_1.Reader(data)));
    }
    MetadataCreatorAll(request) {
        const data = exports.QueryAllMetadataCreatorRequest.encode(request).finish();
        const promise = this.rpc.request("thesixnetwork.sixnft.nftmngr.Query", "MetadataCreatorAll", data);
        return promise.then((data) => exports.QueryAllMetadataCreatorResponse.decode(new minimal_1.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map